import { Chip, Stack, Tooltip } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';

export type ArrayCellValue = Union.Nullable<any[]>;

interface ArrayCellProps<R extends GridValidRowModel = any> {
  value: ArrayCellValue;
  row: R;
  maxItemsVisible?: number;
}

export const ArrayCell = <R extends GridValidRowModel = any>({ value, maxItemsVisible = 3 }: ArrayCellProps<R>) => {
  const { t } = useTranslation();

  if (!value) return <>{NULLISH_CELL_VALUE}</>;

  const visibleItems = value.slice(0, maxItemsVisible);
  const hiddenItemsCount = value.length - maxItemsVisible;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ p: 1, overflow: 'hidden' }}>
      {visibleItems.map((item, index) => {
        const itemString = typeof item === 'object' ? JSON.stringify(item) : String(item);

        return (
          <Tooltip key={index} title={itemString}>
            <Chip
              label={itemString.length > 20 ? `${itemString.slice(0, 20)}...` : itemString}
              size="small"
              variant="outlined"
            />
          </Tooltip>
        );
      })}
      {hiddenItemsCount > 0 && (
        <Tooltip title={t('common:andXMore', { count: hiddenItemsCount }) ?? ''}>
          <Chip label={`+${hiddenItemsCount}`} size="small" />
        </Tooltip>
      )}
    </Stack>
  );
};
